/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Viewer_Body1Inputs */

const en_viewer_body1 = /** @type {(inputs: Viewer_Body1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reading a large payload as text means holding the bracket nesting in your head while you scan. A tree does that for you: each object and array becomes a node you can collapse, so you can hide the ninety percent of the document you do not care about and look only at the branch you do. The raw editor stays alongside it, because sometimes you want to search the text.`)
};

const ko_viewer_body1 = /** @type {(inputs: Viewer_Body1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`큰 페이로드를 텍스트로 읽는다는 것은 훑는 동안 괄호 중첩을 머릿속에 담고 있어야 한다는 뜻입니다. 트리는 그 일을 대신합니다. 각 객체와 배열이 접을 수 있는 노드가 되므로, 관심 없는 문서의 90퍼센트를 숨기고 보려는 가지만 볼 수 있습니다. 원문 에디터는 옆에 남아 있습니다. 텍스트를 검색하고 싶을 때가 있기 때문입니다.`)
};

const ja_viewer_body1 = /** @type {(inputs: Viewer_Body1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`大きなペイロードをテキストとして読むということは、目で追う間かっこのネストを頭の中に保つということです。ツリーはそれを代わりにやります。各オブジェクトと配列が折りたためるノードになるので、興味のない文書の 9 割を隠して、見たい枝だけを見られます。生のエディタは横に残ります。テキストを検索したいときがあるからです。`)
};

/**
* | output |
* | --- |
* | "Reading a large payload as text means holding the bracket nesting in your head while you scan. A tree does that for you: each object and array becomes a node..." |
*
* @param {Viewer_Body1Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const viewer_body1 = /** @type {((inputs?: Viewer_Body1Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Viewer_Body1Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_viewer_body1(inputs)
	if (locale === "ko") return ko_viewer_body1(inputs)
	return ja_viewer_body1(inputs)
});